<template>
  <Modal title="变更记录" v-model="visible" width="1200" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Tabs v-if="visible" v-model="searchParams.type" @on-click="searchAjax()">
      <TabPane label="推荐关系" name="1"></TabPane>
      <TabPane label="辅导关系" name="2"></TabPane>
      <TabPane label="管理关系" name="3"></TabPane>
      <TabPane label="育成关系" name="4"></TabPane>
      <TabPane label="职级记录" name="5"></TabPane>
      <TabPane label="团队长级别" name="6"></TabPane>
    </Tabs>
    <div class="search-box btn3">
      <div class="input-item" style="width: 360px">
        <span class="label">利益归属生效时间</span>
        <DatePicker
          type="daterange"
          format="yyyy-MM-dd"
          separator="至"
          :value="searchParams.date"
          placeholder="请选择"
          @on-change="searchParams.date = $event"
          transfer
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="warning" @click="add">新增</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table class="table1" ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="oldValue">
          <span v-if="searchParams.type == 5">{{ row.oldValue | filterIfaLevel }}</span>
          <span v-else-if="searchParams.type == 6">{{ row.oldValue | filterGroupLevel }}</span>
          <span v-else>{{ row.oldValue | userFilter(userList) }}</span>
        </template>
        <template slot-scope="{ row }" slot="newValue">
          <span v-if="searchParams.type == 5">{{ row.newValue | filterIfaLevel }}</span>
          <span v-else-if="searchParams.type == 6">{{ row.newValue | filterGroupLevel }}</span>
          <span v-else>{{ row.newValue | userFilter(userList) }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="editItem(row)">编辑</span>
          <span class="table-btn" style="color: red" @click="delItem(row)">删除</span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
    <editRelationModal ref="editRelationModal" @success="getList"></editRelationModal>
  </Modal>
</template>

<script>
var vm;
import dayjs from 'dayjs';
import { pageTool } from '@/api/mixins';
import editRelationModal from './editRelationModal';
export default {
  mixins: [pageTool],
  components: { editRelationModal },
  filters: {
    filterGroupLevel(value) {
      let groupLevelMap = {
        0: '',
        1: '合伙人',
        2: '高级合伙人'
      };
      return groupLevelMap[value];
    },
    filterIfaLevel(value) {
      let ifaLevelMap = {
        0: '',
        1: '萌新',
        2: '新贵',
        3: '精英',
        4: '王者'
      };
      return ifaLevelMap[value];
    },
    userFilter(userId, userList) {
      console.log(userId);
      if (!userId) return '';
      return userList.find(item => item.id == userId).name;
    }
  },
  props: {},
  data() {
    return {
      visible: false,
      tableData: [],
      listLoading: false,
      userList: [],
      searchParams: {
        userId: '',
        type: '1' //	变更类型 1=推荐关系 2=辅导关系 3=管理关系 4=育成关系
      },
      //表单搜索字段
      columns: [
        {
          title: '操作时间',
          key: 'createTime',
          align: 'center',
          render(h, params) {
            return <span>{dayjs(params.row.createTime).format('YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '利益归属生效时间',
          key: 'effectiveDate',
          align: 'center',
          render(h, params) {
            return <span>{dayjs(params.row.effectiveDate).format('YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '变更前',
          slot: 'oldValue',
          align: 'center'
        },
        {
          title: '变更后',
          slot: 'newValue',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          fixed: 'right',
          width: 150
        }
      ]
    };
  },
  methods: {
    getUserList() {
      this.$http({
        type: 'POST',
        url: '/buz/userBase/read/list',
        data: {
          pageSize: 9999,
          pageNo: 1,
          isAll: 1
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    add() {
      this.$refs.editRelationModal.open({
        userId: this.searchParams.userId,
        type: this.searchParams.type
      });
    },
    // 转化参数
    setListParams(params) {
      if (params.date && params.date[0]) {
        params.effectStartDate = params.date[0];
        params.effectEndDate = params.date[1];
      }
      delete params.date;
    },
    editItem(row) {
      this.$refs.editRelationModal.open({ ...row, type: this.searchParams.type });
    },
    delItem(row) {
      this.$notice.inquiry('是否删除该数据？').then(() => {
        this.$http({
          url: '/buz/userChangeRecord/del',
          type: 'GET',
          data: { id: row.id }
        })
          .then(res => {
            if (res.httpCode != 1) {
              this.$notice.msg('操作失败');
              return;
            }
            this.$notice.msg('操作成功');
            this.getList();
          })
          .catch(err => {
            console.error(err);
            this.$notice.msg('操作失败');
          });
      });
    },
    open(data) {
      vm = this;
      this.visible = true;
      this.searchParams.userId = data.userId;
      this.searchParams.date = [];
      this.searchParams.type = '1';
      this.getUserList();
      this.initListAjax('/buz/userChangeRecord/read/list');
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-table-cell-slot {
  display: initial;
}

.self {
  color: #236dff;
}

.dian {
  display: block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;

  &.red {
    background: #e3461f;
  }
}
</style>
